import { render, staticRenderFns } from "./SendView.vue?vue&type=template&id=3a4bd756&"
import script from "./SendView.vue?vue&type=script&lang=js&"
export * from "./SendView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SendView.vue"
export default component.exports